// Updated GSAP ScrollTrigger script for all sections
// Make sure GSAP and ScrollTrigger are loaded before this script

// Wait until DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // === SECTION 1: Policy Scroll Animation ===
  const policyRoot = document.querySelector('.s-policy');
  
  if (policyRoot) {
    const contentRoot = policyRoot.querySelector('.s-policy__content');
    if (!contentRoot) return;
  
    const animatedEls = contentRoot.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, p, ul, ol, li, blockquote, img'
    );
  
    animatedEls.forEach((el, i) => {
      let fromProps = { opacity: 0, y: 20 };
      let toProps = {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 90%',
          toggleActions: 'play none none reverse'
        }
      };
  
      if (el.matches('li')) {
        toProps.delay = 0.05 * (i % 5);
      }
  
      if (el.tagName.toLowerCase() === 'img') {
        fromProps = { opacity: 0, scale: 1.05 };
        toProps = {
          opacity: 1,
          scale: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        };
      }
  
      gsap.fromTo(el, fromProps, toProps);
    });
  }

  // === SECTION 2: Subscription Section Animation ===
  const subscriptionSection = document.querySelector('.s-subscription');
  if (subscriptionSection) {
    const title = subscriptionSection.querySelector('.s-subscription__title');
    const description = subscriptionSection.querySelector('.s-subscription__description');
    const form = subscriptionSection.querySelector('.s-subscription__form');
    const imageWrapper = subscriptionSection.querySelector('.s-subscription__image-wrapper');
    const subscribeButton = subscriptionSection.querySelector('.s-subscription__button');
  
    // Fade up & stagger for text + form (repeatable)
    gsap.from([title, description, form], {
      y: 20,
      opacity: 0,
      stagger: 0.2,
      duration: 0.6,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: subscriptionSection,
        start: 'top 80%',
        end: 'bottom 0%',
        toggleActions: 'play reverse play reverse',
      },
    });
  
    // Cat illustration animation (repeatable)
    if (imageWrapper) {
      gsap.fromTo(
        imageWrapper,
        { x: 40, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          ease: 'elastic.out(1, 0.4)',
          scrollTrigger: {
            trigger: imageWrapper,
            start: 'top 80%',
            end: 'bottom 0%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }

    // Animate button pop-in (Subscribe)
    if (subscribeButton) {
      gsap.fromTo(
        subscribeButton,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.5,
          duration: 0.5,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: subscribeButton,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  // Always refresh ScrollTrigger to ensure layout is measured correctly
  ScrollTrigger.refresh();
});
